import { Sort } from '@angular/material/sort';
import { TableData } from './../md/md-table/md-table.component';
import { Component, OnInit } from '@angular/core';
import { FirestoreService } from '../shared/services/firestore/firestore.service';
import swal from 'sweetalert2';

declare const $: any;

@Component({
  selector: 'app-virtual-lending',
  templateUrl: './virtual-lending.component.html',
  styleUrls: ['./virtual-lending.component.css']
})
export class VirtualLendingComponent implements OnInit {
  config: any;
  public tableData1: TableData;
  public result = [];
  public sortedData = [];
  public loading: boolean = false;

  constructor(private firestoreService: FirestoreService) { }

  ngOnInit(): void {

    this.loadInformation();

  }

  loadInformation() {
    this.tableData1 = {
      headerRow: ['Prestación', 'Acciones'],
      dataRows: this.sortedData
    };

    this.firestoreService.getLendings().subscribe((lendingsSnapshot) => {
      this.result = [];
      let list = [];
      lendingsSnapshot.forEach((conData: any) => {
        if (conData.payload.doc.data().lendingType === "Virtual") {
          list.push({
            id: conData.payload.doc.id,
            data: conData.payload.doc.data()
          });
        }
      })
      this.result = list.sort((a, b) => {
        return <any>new Date(b.data.creationDate) - <any>new Date(a.data.creationDate)
      })

      this.sortedData = this.result.slice();
      console.log(this.sortedData);
    });

    this.config = {
      itemsPerPage: 15,
      currentPage: 1,
      totalItems: this.result.length
    };
  }

  sortData(sort: Sort) {
    const data = this.result.slice();
    console.log('data', data);
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'creationDate': return compare(a.creationDate, b.creationDate, isAsc);
        default: return 0;
      }
    });
  }

  ngAfterViewInit() {

  }

  pageChanged(event) {
    this.config.currentPage = event;
  }

  showError(msg) {
    $.notify({
      message: msg
    }, {
      type: 'danger',
      timer: 3000,
      placement: {
        from: 'top',
        align: 'right'
      }
    });
  }

  addRow() {
    let obj = {
      id: null,
      data: {
        'name': "Nueva Prestación",
        'lendingType': "Virtual"
      }
    }

    this.sortedData.unshift(obj);
  }

  onUpdate() {
    this.loading = true;
    for (let index = 0; index < this.sortedData.length; index++) {
      const element = this.sortedData[index];
      if (element.id == null) {
        this.firestoreService.createLending(element.data).then(() => {
          console.log('correct creation');
        }, (error) => {
          console.error(error);
        });
      } else {
        this.firestoreService.updateLending(element.id, element.data).then(() => {
          console.log('correct update');
        }, (error) => {
          console.error(error);
        });
      }
    }
    setTimeout(() => {
      swal({
        title: "Información actualizada!",
        // text: "You clicked the button!",
        buttonsStyling: false,
        confirmButtonClass: "btn btn-success",
        type: "success"
      }).then(() => {
        this.loadInformation();
        this.loading = false;
      }).catch(swal.noop)
    }, 4000);
  }

  onCancel() {
    this.loadInformation();
  }

  onDelete(row: any) {
    console.log(row);

    if (row.id !== null) {
      swal({
        title: 'Esta seguro?',
        // text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {

          this.firestoreService.deleteProfessional(row.id).then(() => {
            swal(
              {
                title: 'Confirmado!',
                text: 'Eliminación exitosa',
                type: 'success',
                confirmButtonClass: "btn btn-success",
                buttonsStyling: false
              }
            )
            this.loadInformation();
          }, (error) => {
            // this.showError(error);
            console.log(error);
          })
        }
      })
    } else {
      // this.loadInformation();
      const index = this.sortedData.indexOf(row, 0);
      if (index > -1) {
        this.sortedData.splice(index, 1);
      }
    }

  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}